module.exports = __webpack_public_path__ + "img/IdrisAli-AshqiHajara.290eecd1.jpg";